export default __webpack_public_path__ + "static/media/money_bag.5becba9d.svg";